import { ICargaServiceMock } from "@/services";

export const mockCargaService = (): ICargaServiceMock => ({
  fetch: jest.fn(),
  fetchEstadosCarga: jest.fn(),
  removeAll: jest.fn(),
});
